<form class="ui form" [class.loading]="isLoading" *ngIf="model">
    <p>
        <strong>{{ 'settings.greenhouse-form.endpointUrlLabel' | appTranslate }}</strong>
    </p>
    <p>https://api.humi.ca/job-board/integrations/greenhouse/hire/{{ auth.company.id }}</p>
    <p>
        <strong>{{ 'settings.greenhouse-form.secretKeyLabel' | appTranslate }}</strong>
    </p>
    <p>{{ auth.company.notification_email }}</p>
</form>
